// src/components/NotFound.jsx

import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ textAlign: 'center', marginTop: '4rem' }}>
      <h1>404 Not Found</h1>
      <p>お探しのページは見つかりませんでした。</p>
      <Link to="/">トップに戻る</Link>
    </div>
  );
}
